module.exports = __webpack_public_path__ + "07_bob_black.6883e90f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/07_bob_black.png
// module id = cWW7
// module chunks = 0